import gql from 'graphql-tag'
import client from '@stores/apollo'
import { KeyValueFilter, ValueFilter } from './types'
import { Order, IEmployeeConnectionWithTotal } from '@api/types'
import { EmployeeConnectionWithTotalFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      employees: IEmployeeConnectionWithTotal
    }
  }
}

export interface IVariables {
  assignmentPlanId?: string
  after?: string | null
  sortBy: string
  order: Order
  ValueFilter: ValueFilter[]
  keyValueFilters: KeyValueFilter[]
  filters: KeyValueFilter[]
  first?: number
}

const mutateHandler = handleFetchResult<IPayload, IEmployeeConnectionWithTotal>({
  handler: (data) => data.viewer.company.employees,
  name: 'Employee Connection',
})

export default function list(variables: IVariables): Promise<IEmployeeConnectionWithTotal> {
  const { order = 'ASC', sortBy = 'name' } = variables
  return client.gql.query({ query, variables: { ...variables, order, sortBy } }).then(mutateHandler)
}

export const query = gql`
  query Employees(
    $assignmentPlanId: ID
    $after: String
    $sortBy: SortBy
    $order: Order
    $keyValueFilters: [EmployeeKeyValueFiltersInput]
    $ValueFilter: [FilterEnum]
    $filters: [EmployeeFiltersInput]
    $first: Int
  ) {
    viewer {
      company {
        employees(
          first: $first
          after: $after
          sortBy: $sortBy
          order: $order
          keyValueFilters: $keyValueFilters
          ValueFilter: $ValueFilter
          filters: $filters
          includeOldBuildings: true
        ) {
          counters {
            total
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...EmployeeConnectionWithTotalFragment
            }
          }
        }
      }
    }
  }
  ${EmployeeConnectionWithTotalFragment}
`
